/**
 * Created by FDD on 2017/9/18.
 * @desc 相关配置文件
 */
const config = {
  INDEX_URL: 'https://sakitam-fdd.github.io/HMap/',
  API_URL: '',
  REQUIRE_ACCESS_TOKEN: true,
  ACCESS_TOKEN: null,
  INTERACTIONS: {
    altShiftDragRotate: true,
    doubleClickZoom: true,
    keyboard: true,
    mouseWheelZoom: true,
    shiftDragZoom: true,
    dragPan: true,
    pinchRotate: true,
    pinchZoom: true
  }
};

export default config;
